import CommandBox from "./app/commandBox.tsx";

export default function LoremIpsum() {
  return (
    <div className="bg-white px-6 lg:px-8">
      <div className="mb-10 mx-auto max-w-3xl text-base leading-7 text-gray-700">
        <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          Welcome to the PMT!
        </h1>
        <p className="mt-6 text-xl leading-8">
          If you have have any suggestions or technical issues, reach out to me
          at{" "}
          <a
            className="font-semibold text-sky-600"
            href="mailto:jsombeck@gmail.com"
          >
            jsombeck@gmail.com
          </a>
          .
        </p>
        <p className="mt-3 text-xl leading-8">
          Here are a few common workflows to get started:
        </p>
      </div>
      <CommandBox />
    </div>
  );
}
